import template from './leave_reject.html';
import tr from '../../lib/default-translator.js';

class LeaveRejectViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	async save_reject()
	{
		// Validate
		if ($('#txtRejectionReason').val() == '')
		{
			Grape.alerts.alert({type: 'error', message: tr('Please give a valid reason for rejecting'), title: tr('Error', 'Error')});
			return;
		}

		let data = {
			transaction_id: this.dialog.bindings.transaction_id,
			rejection_reason: $('#txtRejectionReason').val()
		};

		let res = await Grape.fetches.postJSON('/manager/reject_leave_item', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully rejected leave.'), title: tr('Success', 'Success')});
			this.dialog.close(true);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', 	message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};

	close()
	{
		this.dialog.close(false);
	}
};

class LeaveRejectPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveRejectViewModel(this);
		this.bindings = bindings;

		$('#reject_dialog').on('keypress', (e) => {
			let code = (e.keyCode ? e.keyCode : e.which);
			
			if(code == 13) //Enter keycode
				document.getElementById("btn_accept").click();
		});
	};
};

export default {
	name: 'LeaveReject',
	dialog_class: LeaveRejectPage,
	template: template,
	template_filename: 'translation/dialogs/leave_reject',
	provider: 'ps'
};
